<template>
    <span>
        <div v-if="showCard == 'credit-card'" class="billing-card">
            <b-card-text class="d-flex justify-content-between">
                <span><b>CARD TYPE:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.cardType }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>EXPIRATION DATE:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.cardExpirationDate }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>CARD NO:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.cardNumber }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>CARD CVV:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.cardCvv }}
                        </a>
                    </b>
                </span> </b-card-text
            ><b-card-text class="d-flex justify-content-between">
                <span><b>CARD HOLDER:</b></span>
                <span class="text-right">
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.cardHolder }}
                        </a>
                    </b>
                </span>
            </b-card-text>
        </div>
        <div v-else-if="showCard == 'echeck'" class="billing-card echeck">
            <b-card-text class="d-flex justify-content-between">
                <span><b>ROUTING NUMBER:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.eCheckRoutingNumber }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>ACCOUNT NUMBER:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.eCheckAccountNumber }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>ACCOUNT NAME:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.eCheckAccountName }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>BANK NAME:</b></span>
                <span>
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.eCheckBankName }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>ACCOUNT TYPE:</b></span>
                <span class="text-right">
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.eCheckAccountType }}
                        </a>
                    </b>
                </span>
            </b-card-text>
            <b-card-text class="d-flex justify-content-between">
                <span><b>CHECK TYPE:</b></span>
                <span class="text-right">
                    <b>
                        <a href="javascript:void(0)" @click="toggleCardEdit">
                            {{ billingCard.eCheckCheckType }}
                        </a>
                    </b>
                </span>
            </b-card-text>
        </div>
    </span>
</template>

<script>
export default {
    name: 'BillingCardPreview',
    props: {
        showCard: {
            type: String,
            default: 'credit-card',
        },
        billingCard: {
            type: Object,
            required: true,
        },
    },
    methods: {
        toggleCardEdit() {
            this.$emit('toggleCardEdit');
        },
    },
};
</script>

<style scoped lang="scss">
@import '~bootstrap/scss/_functions.scss';
@import '~bootstrap/scss/_variables.scss';
@import '~bootstrap/scss/mixins/_breakpoints.scss';
@import '../../../scss/bootstrap-extended/bootstrap-extended.scss';

:deep(.billing-card) {
    border-radius: 15px;
    padding: 25px;
    box-shadow: inset 1px 1px 10px rgba($primary, 0.1),
        inset -1px -1px 10px #ffffff;

    &.echeck {
        border-radius: 0;
    }

    @include media-breakpoint-up(md) {
        max-width: 400px !important;
    }

    @include media-breakpoint-down(md) {
        max-width: 100% !important;
    }
}
</style>
